import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeople = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.992 18.7373L8.2 20.4003C8.704 20.7783 9 21.3703 9 22.0003V23.0003H1V22.0003C1 21.3703 1.296 20.7783 1.8 20.4003L4.008 18.7373",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.992 5.7373L15.2 7.4003C15.704 7.7783 16 8.3703 16 9.0003V10.0003H8V9.0003C8 8.3703 8.296 7.7783 8.8 7.4003L11.008 5.7373",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.992 18.7373L22.2 20.4003C22.704 20.7783 23 21.3703 23 22.0003V23.0003H15V22.0003C15 21.3703 15.296 20.7783 15.8 20.4003L18.008 18.7373",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPeople;
